import { MatrixClient } from 'matrix-js-sdk';
import { useState, useEffect, useMemo } from 'react';

export const useRoomRoleAccessing = (mx: MatrixClient) => {
  const [currentUserRoles, setCurrentUserRoles] = useState<string[]>([]);

  useEffect(() => {
    const fetchUserRoles = async () => {
      if (mx) {
        try {
          const userId = mx.getUserId();
          if (userId) {
            const profile = await mx.getProfileInfo(userId) as { roles?: string | string[] };
            if (profile?.roles) {
              let rolesArray: string[] = [];
              if (typeof profile.roles === 'string') {
                rolesArray = profile.roles.split(',').map(role => role.trim());
              } else if (Array.isArray(profile.roles)) {
                rolesArray = profile.roles.map(role => String(role).trim());
              }
              setCurrentUserRoles(rolesArray);
            }
          }
        } catch (error) {
          console.error("Failed to fetch user profile or roles:", error);
        }
      }
    };
    fetchUserRoles();
  }, [mx]);

  const canShowPriority = useMemo(() =>
    currentUserRoles.includes('PM') || currentUserRoles.includes('CS') ||  currentUserRoles.includes('User'),
    [currentUserRoles]
  );

  return { currentUserRoles, canShowPriority };
};
